module.exports = __webpack_public_path__ + "4f5903266c2b8b35818fdd21247e3d70.pdf";